document.addEventListener('DOMContentLoaded', () => {

  var $gallery = new SimpleLightbox('.gallery a', {});

  jQuery(".model-colorizer").not('.slick-initialized').slick({
    "dots": false,
    "fade": true,
    "prevArrow": '<button class="slick-prev-model slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.8" d="M36 17.9887C35.8853 7.97728 27.9776 -0.00857919 17.9762 6.91709e-06C7.95615 0.00937358 -0.00857162 8.00928 7.62939e-06 18.0121C0.0093689 28.0586 8.02167 36.0101 17.9996 36C28.0493 35.9898 35.9017 27.954 36 17.9887ZM21.4192 6.20698C21.4738 6.25225 21.5479 6.30377 21.6111 6.36309C22.4847 7.23575 23.3544 8.1131 24.2327 8.98108C24.4184 9.16451 24.4433 9.28315 24.2327 9.48375C23.4106 10.276 22.6064 11.087 21.7998 11.8957C19.9231 13.7799 18.0464 15.665 16.1697 17.5508C15.7446 17.9762 15.7391 17.9715 16.1783 18.4094L24.1999 26.439C24.5705 26.8097 24.5705 26.8105 24.1898 27.1922C23.4098 27.9728 22.6157 28.744 21.8498 29.5425C21.5822 29.8219 21.4293 29.8414 21.1415 29.5518C17.4125 25.7989 13.675 22.0541 9.92881 18.3173C9.56688 17.9551 9.56688 17.9543 9.92023 17.6007C13.384 14.1335 16.8483 10.6668 20.3131 7.20063C20.5885 6.92509 20.8591 6.648 21.1415 6.37402C21.2164 6.30299 21.2765 6.21401 21.4192 6.20698Z" fill="#414042"/></svg></button>',
    "nextArrow": '<button class="slick-next-model slick-arrow" aria-label="Next" type="button" aria-disabled="true"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.8" d="M0 17.9887C0.114662 7.97728 8.02245 -0.00857919 18.0238 6.91709e-06C28.0438 0.00937358 36.0086 8.00928 36 18.0121C35.9906 28.0586 27.9783 36.0101 18.0004 36C7.95068 35.9898 0.0982818 27.954 0 17.9887ZM14.5808 6.20698C14.5262 6.25225 14.4521 6.30377 14.3889 6.36309C13.5153 7.23575 12.6456 8.1131 11.7673 8.98108C11.5816 9.16451 11.5567 9.28315 11.7673 9.48375C12.5894 10.276 13.3936 11.087 14.2002 11.8957C16.0769 13.7799 17.9536 15.665 19.8303 17.5508C20.2554 17.9762 20.2609 17.9715 19.8217 18.4094L11.8001 26.439C11.4295 26.8097 11.4295 26.8105 11.8102 27.1922C12.5902 27.9728 13.3843 28.744 14.1502 29.5425C14.4178 29.8219 14.5707 29.8414 14.8585 29.5518C18.5875 25.7989 22.325 22.0541 26.0712 18.3173C26.4331 17.9551 26.4331 17.9543 26.0798 17.6007C22.616 14.1335 19.1517 10.6668 15.6869 7.20063C15.4115 6.92509 15.1409 6.648 14.8585 6.37402C14.7836 6.30299 14.7235 6.21401 14.5808 6.20698Z" fill="#414042"/></svg></button>',
    "infinite": true,
    "speed": 500,
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "initialSlide": 0,
    "responsive": [{
        "breakpoint": 1440,
        "settings": {
          "slidesToShow": 1,
          "slidesToScroll": 1,
          "infinite": true,
          "dots": false
        }
      },
      {
        "breakpoint": 1281,
        "settings": {
          "slidesToShow": 1,
          "slidesToScroll": 1,
          "initialSlide": 0,
          "infinite": true,
          "dots": false
        }
      },
      {
        "breakpoint": 1024,
        "settings": {
          "slidesToShow": 1,
          "slidesToScroll": 1,
          "initialSlide": 0,
          "infinite": true,
          "dots": false
        }
      },
      {
        "breakpoint": 771,
        "settings": {
          "slidesToShow": 1,
          "slidesToScroll": 1,
          "initialSlide": 0,
          "infinite": true,
          "dots": false
        }
      }
    ]

  });

  // GET THE INDEX OF THE SLIDE BEFORE THE CHANGE
  jQuery('.model-colorizer').on('beforeChange', function(e, s, currentSlideIndex, nextSlide) {
      jQuery(`div[id!='${s.$slider[0].id}'].model-colorizer`).slick('unslick');
      jQuery(`div[id!='${s.$slider[0].id}'].model-colorizer`).slick({
        "dots": false,
        "fade": true,
        "prevArrow": '<button class="slick-prev-model slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.8" d="M36 17.9887C35.8853 7.97728 27.9776 -0.00857919 17.9762 6.91709e-06C7.95615 0.00937358 -0.00857162 8.00928 7.62939e-06 18.0121C0.0093689 28.0586 8.02167 36.0101 17.9996 36C28.0493 35.9898 35.9017 27.954 36 17.9887ZM21.4192 6.20698C21.4738 6.25225 21.5479 6.30377 21.6111 6.36309C22.4847 7.23575 23.3544 8.1131 24.2327 8.98108C24.4184 9.16451 24.4433 9.28315 24.2327 9.48375C23.4106 10.276 22.6064 11.087 21.7998 11.8957C19.9231 13.7799 18.0464 15.665 16.1697 17.5508C15.7446 17.9762 15.7391 17.9715 16.1783 18.4094L24.1999 26.439C24.5705 26.8097 24.5705 26.8105 24.1898 27.1922C23.4098 27.9728 22.6157 28.744 21.8498 29.5425C21.5822 29.8219 21.4293 29.8414 21.1415 29.5518C17.4125 25.7989 13.675 22.0541 9.92881 18.3173C9.56688 17.9551 9.56688 17.9543 9.92023 17.6007C13.384 14.1335 16.8483 10.6668 20.3131 7.20063C20.5885 6.92509 20.8591 6.648 21.1415 6.37402C21.2164 6.30299 21.2765 6.21401 21.4192 6.20698Z" fill="#414042"/></svg></button>',
        "nextArrow": '<button class="slick-next-model slick-arrow" aria-label="Next" type="button" aria-disabled="true"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.8" d="M0 17.9887C0.114662 7.97728 8.02245 -0.00857919 18.0238 6.91709e-06C28.0438 0.00937358 36.0086 8.00928 36 18.0121C35.9906 28.0586 27.9783 36.0101 18.0004 36C7.95068 35.9898 0.0982818 27.954 0 17.9887ZM14.5808 6.20698C14.5262 6.25225 14.4521 6.30377 14.3889 6.36309C13.5153 7.23575 12.6456 8.1131 11.7673 8.98108C11.5816 9.16451 11.5567 9.28315 11.7673 9.48375C12.5894 10.276 13.3936 11.087 14.2002 11.8957C16.0769 13.7799 17.9536 15.665 19.8303 17.5508C20.2554 17.9762 20.2609 17.9715 19.8217 18.4094L11.8001 26.439C11.4295 26.8097 11.4295 26.8105 11.8102 27.1922C12.5902 27.9728 13.3843 28.744 14.1502 29.5425C14.4178 29.8219 14.5707 29.8414 14.8585 29.5518C18.5875 25.7989 22.325 22.0541 26.0712 18.3173C26.4331 17.9551 26.4331 17.9543 26.0798 17.6007C22.616 14.1335 19.1517 10.6668 15.6869 7.20063C15.4115 6.92509 15.1409 6.648 14.8585 6.37402C14.7836 6.30299 14.7235 6.21401 14.5808 6.20698Z" fill="#414042"/></svg></button>',
        "infinite": true,
        "speed": 500,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "initialSlide": nextSlide,
        "responsive": [{
            "breakpoint": 1440,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1,
              "infinite": true,
              "dots": false
            }
          },
          {
            "breakpoint": 1281,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1,
              "initialSlide": nextSlide,
              "infinite": true,
              "dots": false
            }
          },
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1,
              "initialSlide": nextSlide,
              "infinite": true,
              "dots": false
            }
          },
          {
            "breakpoint": 771,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1,
              "initialSlide": nextSlide,
              "infinite": true,
              "dots": false
            }
          }
        ]
    
      });
  });

  jQuery('.trims-container').not('.slick-initialized').slick({
    "dots": false,
    "prevArrow": '<button class="slick-prev-trims slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.8" d="M36 17.9887C35.8853 7.97728 27.9776 -0.00857919 17.9762 6.91709e-06C7.95615 0.00937358 -0.00857162 8.00928 7.62939e-06 18.0121C0.0093689 28.0586 8.02167 36.0101 17.9996 36C28.0493 35.9898 35.9017 27.954 36 17.9887ZM21.4192 6.20698C21.4738 6.25225 21.5479 6.30377 21.6111 6.36309C22.4847 7.23575 23.3544 8.1131 24.2327 8.98108C24.4184 9.16451 24.4433 9.28315 24.2327 9.48375C23.4106 10.276 22.6064 11.087 21.7998 11.8957C19.9231 13.7799 18.0464 15.665 16.1697 17.5508C15.7446 17.9762 15.7391 17.9715 16.1783 18.4094L24.1999 26.439C24.5705 26.8097 24.5705 26.8105 24.1898 27.1922C23.4098 27.9728 22.6157 28.744 21.8498 29.5425C21.5822 29.8219 21.4293 29.8414 21.1415 29.5518C17.4125 25.7989 13.675 22.0541 9.92881 18.3173C9.56688 17.9551 9.56688 17.9543 9.92023 17.6007C13.384 14.1335 16.8483 10.6668 20.3131 7.20063C20.5885 6.92509 20.8591 6.648 21.1415 6.37402C21.2164 6.30299 21.2765 6.21401 21.4192 6.20698Z" fill="#414042"/></svg></button>',
    "nextArrow": '<button class="slick-next-trims slick-arrow" aria-label="Next" type="button" aria-disabled="true"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.8" d="M0 17.9887C0.114662 7.97728 8.02245 -0.00857919 18.0238 6.91709e-06C28.0438 0.00937358 36.0086 8.00928 36 18.0121C35.9906 28.0586 27.9783 36.0101 18.0004 36C7.95068 35.9898 0.0982818 27.954 0 17.9887ZM14.5808 6.20698C14.5262 6.25225 14.4521 6.30377 14.3889 6.36309C13.5153 7.23575 12.6456 8.1131 11.7673 8.98108C11.5816 9.16451 11.5567 9.28315 11.7673 9.48375C12.5894 10.276 13.3936 11.087 14.2002 11.8957C16.0769 13.7799 17.9536 15.665 19.8303 17.5508C20.2554 17.9762 20.2609 17.9715 19.8217 18.4094L11.8001 26.439C11.4295 26.8097 11.4295 26.8105 11.8102 27.1922C12.5902 27.9728 13.3843 28.744 14.1502 29.5425C14.4178 29.8219 14.5707 29.8414 14.8585 29.5518C18.5875 25.7989 22.325 22.0541 26.0712 18.3173C26.4331 17.9551 26.4331 17.9543 26.0798 17.6007C22.616 14.1335 19.1517 10.6668 15.6869 7.20063C15.4115 6.92509 15.1409 6.648 14.8585 6.37402C14.7836 6.30299 14.7235 6.21401 14.5808 6.20698Z" fill="#414042"/></svg></button>',
    "infinite": false,
    "speed": 500,
    "slidesToShow": 3,
    "slidesToScroll": 1,
    "initialSlide": 0,
    "responsive": [{
        "breakpoint": 1440,
        "settings": {
          "slidesToShow": 3,
          "slidesToScroll": 1,
          "infinite": false,
          "dots": false
        }
      },
      {
        "breakpoint": 1281,
        "settings": {
          "slidesToShow": 3,
          "slidesToScroll": 1,
          "initialSlide": 0,
          "infinite": false,
          "dots": false
        }
      },
      {
        "breakpoint": 1024,
        "settings": {
          "slidesToShow": 2,
          "slidesToScroll": 1,
          "initialSlide": 0,
          "infinite": false,
          "dots": false
        }
      },
      {
        "breakpoint": 771,
        "settings": {
          "slidesToShow": 1,
          "slidesToScroll": 1,
          "initialSlide": 0,
          "infinite": false,
          "dots": false
        }
      }
    ]

  });

  const btnColor = document.querySelectorAll('.div-colors .cursor-pointer');
  btnColor.forEach(btn => {
    btn.addEventListener('click', () => {
      // Firefox no ancla el scroll cuando la altura cambia por un display:none, y la
      // página salta al ocultar el contenedor del color anterior.
      const scrollY = window.scrollY;
      let selectedFilter = btn.getAttribute('data-filter');
      let colorName = btn.getAttribute('data-colorName');
      selectedFilter = selectedFilter.split('|')[1];

      let itemsToHide = document.querySelectorAll(`.colorizer-section .colorizer-image-container:not([data-filter='${selectedFilter}'])`);
      let itemsToShow = document.querySelectorAll(`.colorizer-section [data-filter='${selectedFilter}']`);
      document.querySelector('.color-name').innerHTML = colorName;

      jQuery(`.round-color`).removeClass("active");
      jQuery(`[data-filter='round|${selectedFilter}']`).addClass("active");
      
      itemsToHide.forEach(el => {
        el.classList.add('hidden');
        el.classList.remove('block');
      });
      
      itemsToShow.forEach(el => {
        el.classList.remove('hidden');
        el.classList.add('block');
      });
      
      jQuery('.model-colorizer').slick('refresh');

      window.scrollTo(0, scrollY);
      requestAnimationFrame(() => window.scrollTo(0, scrollY));
    })
  })

  const btnGallery = document.querySelectorAll('.vg');
  btnGallery.forEach(el => {
    el.addEventListener('click', () => {
      let selectedFilter = el.getAttribute('data-filter');
      if(selectedFilter == 'all') {

        jQuery(".img-exterior").fadeIn("slow");
        jQuery(".img-interior").fadeIn("slow");
        jQuery(".vg").removeClass("active")
        jQuery(".view-full-gallery").addClass("active")
        document.querySelector('.view-full-gallery').dataset.filter = "less";
      
      }else if(selectedFilter == 'less') {

        jQuery(".img-interior").fadeOut("slow");
        jQuery(".vg").removeClass("active")
        jQuery(".view-full-gallery").addClass("active")
        document.querySelector('.view-full-gallery').dataset.filter = "all";

      }else if(selectedFilter == 'exterior'){
        
        jQuery(".img-interior").fadeOut("slow", function(){
          jQuery(".img-exterior").fadeIn("fast");
        });
        jQuery(".vg").removeClass("active")
        jQuery(".view-exterior-gallery").addClass("active")
        document.querySelector('.view-full-gallery').dataset.filter = "all";

      }else if(selectedFilter == 'interior'){

        jQuery(".img-exterior").fadeOut("slow", function(){
          jQuery(".img-interior").fadeIn("fast");
        });
        jQuery(".vg").removeClass("active")
        jQuery(".view-interior-gallery").addClass("active")
        document.querySelector('.view-full-gallery').dataset.filter = "all";

      }

    })
  });
});